// extracted by mini-css-extract-plugin
export default {"root":"QuestionStep_root__iB+wy","question":"QuestionStep_question__wYSa1","optionsContainer":"QuestionStep_optionsContainer__sDDSZ"};